<template>
    <div>
        <div class="comcard" @click="goto(product)">
            <div class="comcardinfo">
                 <div class="comimg">
                    <img :src="$baseurl+product.productImageUrl">
                </div>
                <div class="comproduct">
                    <div class="com-header">
                        <div class="com-header-left van-multi-ellipsis--l2">{{product.productName}}</div>
                        <div class="com-header-right">{{isIntegralTrade?'积分':'￥'}} {{product.price}}</div>
                    </div>
                    <div class="clearboth"></div>
                    <div v-if="product.isSeaProduct" :style="{color:$abctheme.basecolor}">
                        【海外产品】
                    </div>
                    <div class="com-main">
                        <span class="com-main-sbg">{{product.specName}}</span>
                        <span class="com-right">x{{product.num2}}</span>
                    </div>
                    <div class="clearboth"></div>
                    <div v-if="product.cartonSize" class="com-main">
                        <span class="com-main-sbg">箱规:{{product.cartonSize+product.unit+"/箱"}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'comtradecard',
    props: {
        product: Object,
        iscard: {
            type: Boolean,
            default: false
        },
        isIntegralTrade:{
             type: Boolean,
            default: false
        }
    },
    methods: {
        goto(item) {
            var productsku = item.productSku;
            this.$router.push({
                path: '/product/' + productsku
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .comcard{
        background-color: white;
        margin-bottom: 10px;
    }
    .comcardinfo{
        position: relative;
        padding-left:110px;
    }
    .comimg{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0,-50%);
        width: 100px;
        height: 100px;
    }
    .clearboth{
        clear:both;
    }
    .comimg img{
        width: 100%;
        height: 100%;
        border-radius: 8px;
    }
    .comproduct{
        min-height: 100px;
        font-size: 12px;
    }
    .com-header{
        padding-right: 66px;
        position: relative;
        font-size: 15px;
        margin-bottom: 5px;
    }
    .com-header-left{
        word-break: break-all;
    }
    .com-header-right{
        position: absolute;
        right: 0;
        top: 0;
        font-size: 14px;
    }
    .com-left{
        float: left;
    }
    .com-right{
        float: right;
    }
    .com-main{
        color:#a7a7a7;
        margin-bottom: 5px;
    }
    .com-main-sbg{
        padding: 2px 6px;
        border-radius: 999px;
        background-color: #eee;
    }
</style>
